// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2Cafp","messages":"Chat_messages__3MrAD","dateDivider":"Chat_dateDivider__2PKTh"};